import React from 'react';
import ReactDOM from 'react-dom';
import {
    ButtonGroup,
    Div,
    Avatar,
    RichCell,
    View,
    Panel,
    PanelHeader,
    Group,
    List,
    Textarea,
    PanelHeaderButton,
    Progress,
    PanelHeaderContent,
    SplitCol,
    SplitLayout,
    SizeType,
    ModalRoot,
    ModalPage,
    ModalPageHeader,
    FormItem,
    RadioGroup, Radio, CellButton, Button, Chip, SimpleCell, Switch, NativeSelect, Search
} from '@vkontakte/vkui';
import axios from "axios";
import * as constants from "../assets/constants";
import {AdaptivityContext, longDateTimeFormat, MODAL_SEND_MONITORING, monitoring_items_key} from "../assets/constants";
import {
    Icon16Clear,
    Icon16Pen,
    Icon24Story,
    Icon24BrowserBack, Icon24Cancel, Icon24Done,
    Icon24Search,
    Icon28ClearDataOutline,
    Icon28CloudArrowUpOutline
} from "@vkontakte/icons";
import moment from "moment";
import Fancybox from "../assets/fancybox";
import CartApi from "../api/CartApi";

class MonitoringCreate extends React.Component {
    state = {
        current_komment: '',
        showSearch: false,
        mainSearch: '',
        activeModal: null,
        modalHistory: [],
        loading: false,
        items: []
    }
    receiveMessage = (event) => {

        if (event.data.type != undefined) {
            if (event.data.type == "setMonitoringImage") {
                let items = this.state.items_monitoring ? this.state.items_monitoring : {}
                if (items[this.props.current_product.id] == undefined) {
                    items[this.props.current_product.id] = {}
                }
                items[this.props.current_product.id].hasImage = true
                items[this.props.current_product.id].mainImage = event.data.data.image
                items[this.props.current_product.id].thumb = event.data.data.thumb
                items[this.props.current_product.id].datetime = new Date()


                this.setState({items_monitoring: items})
                localStorage.setItem(monitoring_items_key, JSON.stringify(items))
                let old = this.state.items
                if (items && old) {
                    old.map((el, index) => {
                        if (items[el.id] != undefined) {
                            old[index].hasImage = items[el.id].hasImage
                            old[index].mainImage = items[el.id].mainImage
                            old[index].thumb = items[el.id].thumb
                            old[index].datetime = items[el.id].datetime
                        }
                    })
                }
                this.validateDoc()
            }
        }

    }
    onSearchChange = (state) => {

        clearInterval(this.searchInterval);
        this.setState({mainSearch: state.target.value, page: 1});
        this.searchInterval = setInterval(() => {
            // console.log(state);

            this.getItems(this.state.mainSearch);
        }, state.target.value == '' ? 500 : 2000);

    }


    setActiveModal(activeModal) {
        activeModal = activeModal || null;
        let modalHistory = this.state.modalHistory ? [...this.state.modalHistory] : [];

        if (activeModal === null) {
            modalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            modalHistory = modalHistory.splice(0, modalHistory.indexOf(activeModal) + 1);
        } else {
            modalHistory.push(activeModal);
        }

        this.setState({
            activeModal,
            modalHistory
        });
    };

    constructor(props) {
        super(props);
        this.modalBack = () => {
            this.setActiveModal(this.state.modalHistory[this.state.modalHistory.length - 2]);
        };
        const data = localStorage.getItem(monitoring_items_key)
        window.addEventListener("message", this.receiveMessage, false)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            console.log(items)
            this.state.items_monitoring = items
        }
    }

    getItems = (mainSearch, append, page) => {
        if (Object.keys(this.state.items_monitoring).length == 0) return;
        let ids = []

        Object.keys(this.state.items_monitoring).map((key, index) => {
            ids.push(key)
        })

        append = append == undefined ? false : append

        clearInterval(this.searchInterval)
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }

        if (page == undefined) {
            page = 1;
        }


        let body = new FormData()
        body.append('group', '')
        body.append('sSearch', mainSearch)
        body.append('ids', JSON.stringify(ids))
        body.append('page', page)
        body.append('epp', AdaptivityContext.isMobile ? 10 : 25)


        this.setState({loading: true})

        axios.post(this.props.base_url + '?app=partnersproducts&act=searchProducts', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            // console.log(response)

            this.setState({totalItems: response.data.total});
            this.setState({totalPages: response.data.totalPages});
            this.setState({Alfavit: response.data.Alfavit});
            this.setState({parent_group_id: response.data.parent_group_id});
            let old = this.state.items;
            console.log(this.state.items_monitoring)

            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            if (this.state.items_monitoring) {
                old.map((el, index) => {
                    if (this.state.items_monitoring[el.id] != undefined) {
                        old[index].hasImage = this.state.items_monitoring[el.id].hasImage
                        old[index].mainImage = this.state.items_monitoring[el.id].mainImage
                        old[index].thumb = this.state.items_monitoring[el.id].thumb
                        old[index].datetime = this.state.items_monitoring[el.id].datetime ? this.state.items_monitoring[el.id].datetime : ''
                        old[index].hasMonitoring = this.state.items_monitoring[el.id].hasMonitoring === true
                    }
                })
            }
            this.setState({items: old, loading: false});
            this.setState({path: response.data.path});


        })

    };


    componentDidMount = () => {


        this.getItems()


    }
    backClick = () => {
        window.postMessage('goToMonitoring')
    }
    toDocs = () => {
        window.postMessage('goToMonitoringDocs')
    }


    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }
    changeCurrentProduct = async (item) => {


        await this.props.changeCurrentProduct(item);
        //   this.props.showSclads();
    };

    render() {

        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEND_MONITORING}
                           onClose={this.modalBack}
                           settlingHeight={100}
                           style={{
                               width: "100%"
                           }}
                           header={
                               <ModalPageHeader aria-multiline={true}
                                                after={<PanelHeaderButton
                                                    onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Создать новый "мониторинг"
                               </ModalPageHeader>
                           }
                >
                    <Div>
                        <FormItem top="Комментарий к документу">
                            <Textarea rows={7} value={this.state.current_komment}
                                      onChange={(e) => this.setState({current_komment: e.target.value})}/>
                        </FormItem>
                        <p>Создать и отправить документ мониторинг в 1С?</p>
                    </Div>
                    <Div>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button before={<Icon24Done/>} size="l" stretched onClick={() => this.sendDoc()}>Да</Button>
                            <Button before={<Icon24Cancel/>} size="l" stretched
                                    onClick={() => this.setActiveModal(null)}>Нет</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
            </ModalRoot>)

        const images_url = this.props.base_url.replace("frontend/", '');

        moment.locale('ru')
        return ([
            <PanelHeader className={'main-catalog_header ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}
                         after={<Button onClick={() => {
                             if (this.validateDoc()) this.setActiveModal(constants.MODAL_SEND_MONITORING)
                         }}>Создать</Button>}
                         before={[
                             <PanelHeaderButton style={{display: 'inline'}} onClick={() => {
                                 this.backClick()
                             }} key="cmd_back"><Icon24BrowserBack/>
                             </PanelHeaderButton>,
                             AdaptivityContext.isMobile ? <PanelHeaderButton style={{display: 'inline'}}
                                                                             onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : '']}


            >

                {this.state.showSearch || !AdaptivityContext.isMobile ?
                    <Search autoFocus

                            theme="header"
                            placeholder="Поиск"
                            value={this.state.mainSearch}
                            onChange={this.onSearchChange}
                            onClose={this.toggleSearch}

                            style={{flexGrow: '1', maxWidth: '350px'}}
                    /> : 'Новый мониторинг'

                }

            </PanelHeader>,


            <SplitLayout modal={modals}>
                <List style={{marginRight: '28px', marginLeft: '11px'}}>
                    <Fancybox key={'MonitoringFancyBox'}>
                        {this.state.items.map((item, index) => {
                            return <div key={'MonitoringProduct' + index}
                                        className={"main-catalog_product " + (item.error ? 'error' : '')}>

                                <div className="main-catalog_product-wrapper" style={{height: item.hasImage?170:142}} >
                                    <div className="main-catalog_product-wrapper_avatar">
                                        {item.hasImage?

                                            [<a data-fancybox={'gallery' + item.id} href={item.mainImage }>
                                                {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                         size={AdaptivityContext.isMobile ? 140 : 200}
                                                         src={item.thumb }/>}
                                            </a>,
                                                <ButtonGroup stretched>
                                                    <Button mode="outline" stretched size="s"
                                                            onClick={() => {
                                                                this.changeCurrentProduct(item.id)
                                                            }}><Icon24Story /></Button>
                                                    <Button  mode="outline" stretched size="s"
                                                             onClick={() => {
                                                                 this.clearPhoto(index)
                                                             }}><Icon16Clear /></Button>
                                                </ButtonGroup>]
                                            :
                                            <Avatar mode="image" style={{borderRadius: '5%'}}
                                                    onClick={() => {
                                                        this.changeCurrentProduct(item.id)
                                                    }}
                                                    size={AdaptivityContext.isMobile ? 140 : 200}
                                                    src={images_url + constants.EMPTY_IMG}/>
                                        }
                                    </div>
                                    <div style={{display: "flex", flexDirection:"column", height: "100%", alignItems: "stretch", justifyContent: "space-between"}}>
                                        <div
                                            className={'main-catalog_product-wrapper_name ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}
                                        >{item.name}<hr/><small>{item.datetime? 'Изображение получено: '+ moment(item.datetime).format(longDateTimeFormat):''}</small></div>

                                        <SimpleCell Component="label" style={{display: "flex", justifyContent: "flex-end", alignItems:"center", marginBottom:"-12px"}} after={<Switch checked={item.hasMonitoring} onChange={(e) => this.changeHasMonitoring(e, index)} />}>
                                            Выставка
                                        </SimpleCell>

                                    </div>
                                </div>

                                {item.error ? <span className="error red">{item.error}</span> : ''}
                            </div>
                        })}
                    </Fancybox>
                </List>
            </SplitLayout>])
    }
    clearPhoto = (index) => {
        let items = this.state.items_monitoring?this.state.items_monitoring:{}
        let old = this.state.items
        let current_product = this.state.items[index]
        if(items[current_product.id] == undefined){
            items[current_product.id] = {}
        }
        items[current_product.id].hasImage = false
        old[index].hasImage = false

        this.setState({items_monitoring: items})
        this.setState({items: old})
        localStorage.setItem(monitoring_items_key, JSON.stringify(items))
    }

    changeHasMonitoring = (e, index) => {
        let items = this.state.items_monitoring ? this.state.items_monitoring : {}
        let old = this.state.items
        let current_product = this.state.items[index]
        if (items[current_product.id] == undefined) {
            items[current_product.id] = {}
        }
        items[current_product.id].hasMonitoring = e.target.checked
        old[index].hasMonitoring = e.target.checked

        this.setState({items_monitoring: items})
        this.setState({items: old})
        localStorage.setItem(monitoring_items_key, JSON.stringify(items))
    }
    validateDoc = () => {
        let errors = 0
        if (Object.keys(this.state.items_monitoring).length == 0) {
            window.postMessage({type: 'error', text: 'Мониторинг пустой. Добавьте хотя бы одну позицию'})
            errors++
            return false
        }
        let old = this.state.items
        old.map((item, index) => {

            delete old[index].error

            if (!item.hasImage && item.hasMonitoring) {
                errors++
                old[index].error = 'Необходимо сделать фотофиксацию!'
            }
        })

        this.setState({items: old})
        return errors == 0
    }

    sendDoc = () => {


        this.setActiveModal(null)

        this.props.openLoadingNoty("Немного подождите...Создаем документ, не закрывайте окно")
        this.setState({send_order_pending: true})

        let body = new FormData()
        this.state.items.map((pos, i) => {
            if (!pos.hasMonitoring) return

            body.append('items[]', pos.id);
            body.append("names[]", pos.name)
            body.append("image[]", pos.mainImage)
            body.append("date[]", pos.datetime)
        });


        let komment = this.state.current_komment;


        let sAjaxSource = '/?app=monitoringdocs&act=addDoc'


        body.append("komment", komment)
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }

            }
        ).then((response) => {


            if (response.data.code == "+ok") {
                this.props.openLoadingNoty("Уже не долго... Выгружаем документ в 1С, не закрывайте окно!")
                this.setState({current_komment: ''})
                // saveCartComment();
                //order_comments =[];
                //localStorage.setItem(name_order_comments, JSON.stringify(order_comments));

                CartApi.items = []
                CartApi.saveItems()


                axios.get(this.props.base_url + '/?app=monitoringdocs&act=exportDocToWebService&doc_id=' + response.data.doc,
                    {
                        withCredentials: true


                    }
                ).then(
                    (response2) => {
                        this.props.openLoadingNoty("Готово, документ успешно создан!", 2000)
                        localStorage.setItem(monitoring_items_key, "{}")
                        this.toDocs()
                    }
                )


            }
        })
    }
}

export default MonitoringCreate